<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(updateAritcle)">
      <md-card>
        <md-card-header
          class="md-card-header-icon"
          :class="getClass(headerColor)"
        >
          <div class="card-icon">
            <md-icon>account_balance</md-icon>
          </div>
          <h4 class="title">Article - <small>Update</small></h4>
        </md-card-header>

        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="title"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                  <md-icon>account_balance</md-icon>
                  <label>Title</label>
                  <md-input v-model="title" type="text"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider name="program_type" v-slot="{ passed, failed }">
                <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                  <label>Category</label>
                  <md-select
                    v-model="category"
                    name="category"
                  >
                    <md-option value="">Select Category</md-option>
                    <md-option value="1">Application</md-option>
                    <md-option value="2">Accommodation</md-option>
                    <md-option value="3">Life in Turkey</md-option>
                    <md-option value="4">Cost and Funding</md-option>
                    <md-option value="5">University and Course</md-option>
                    <md-option value="6">City Guide</md-option>
                    <md-option value="7">Subject Guide</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-100 md-small-size-100">
              <ValidationProvider
                name="short_info"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                  <md-icon>account_balance</md-icon>
                  <label>Short Info</label>
                  <md-input v-model="short_info" type="text"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="image"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Image</label>
                  <md-file
                    v-model="image"
                    name="image"
                    @change="onFileChange"
                  />

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <div class="md-layout-item md-size-25 md-small-size-100">
              <md-checkbox v-model="is_public">Is Public?</md-checkbox>
            </div>

            <div class="md-layout-item md-size-100 md-small-size-100" style="margin-top: 20px">
              <label>Content</label>
              <ckeditor :editor="editor" v-model="content" :config="editorConfig"></ckeditor>
            </div>

            <div class="md-layout-item md-size-100 text-right">
              <md-button type="submit" class="md-raised md-success mt-4"
                >Update Article
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, numeric } from "vee-validate/dist/rules";
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

extend("required", required);
extend("numeric", numeric);

export default {
  components: {
    SlideYDownTransition,
    ckeditor: CKEditor.component
  },
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      articleID: null,

      editor: ClassicEditor,
      editorConfig: {},

      title: null,
      category: null,
      short_info: null,
      content: null,
      image: null,
      image_data: null,
      is_public: false
    };
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.image_data = files[0];
    },
    updateAritcle() {
      let data = {
        title: this.title,
        category: this.category,
        short_info: this.short_info,
        content: this.content,
        image: this.image_data,
        is_public: this.is_public
      };
      var post_data = {};
      for (const field in data) {
        if (
          data[field] === null ||
          data[field] === undefined ||
          data[field] === ""
        ) {
          continue;
        }
        if (data[field] instanceof Date) {
          post_data[field] = data[field]
            .toLocaleDateString("ko-KR")
            .replaceAll(". ", "-")
            .replaceAll(".", "");
        } else {
          post_data[field] = data[field];
        }
      }
      this.$store
        .updateArticle(post_data, this.articleID)
        .then(response => {
          this.$notify({
            message: "Article updated.",
            icon: "add_alert",
            type: "success",
            verticalAlign: "top",
            timeout: 3000
          });
        })
        .catch(error => {
          var message = error.response.data;
          this.$notify({
            message: JSON.stringify(message),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top",
            timeout: 3000
          });
        });
    }
  },
  mounted() {
    this.articleID = this.$route.params.id;
  }
};
</script>
